// Copyright (c) Docugami, Inc. All rights reserved.

import { ComponentId } from "sdv/engine/Component";
import { IEntityManager } from "sdv/engine/Entity";
import { createTokenRangeBoxes } from "sdv/utils/TokenBounds";
import { ISystem, Queries } from "../engine/Engine";
import { IResources, ResourceDependencies } from "../Resources";
import { TokenLinesComponent } from "sdv/components/TokenLinesComponent";
import { IInput } from "sdv/input/InputController";

const shouldUpdateDeps: ResourceDependencies = ["pagesLoaded", "visiblePages"];

export class TokenLinesSystem implements ISystem {
    get updateEnabled() { return true; }

    resources!: IResources;
    entities!: IEntityManager;
    input!: IInput;

    queries: Queries = {
        tokenLines: {
            types: [ComponentId.TokenLines]
        }
    }

    update() {
        this.updateTokenLines();
        this.handleTextVersion();
    }

    private handleTextVersion() {
        if (this.resources.check("textVersion")) {
            this.queries.tokenLines.query!.single()?.destroy();
        }
    }

    private updateTokenLines() {
        let tokenLinesComp = this.queries.tokenLines.query!.single()?.getComponent<TokenLinesComponent>(ComponentId.TokenLines)!;
        if (!tokenLinesComp) {
            tokenLinesComp = { typeId: ComponentId.TokenLines, tokenLines: {} };
            this.entities.create().addComponent(tokenLinesComp);
        }

        if (!this.resources.check(shouldUpdateDeps) || !this.resources.get("pagesLoaded").value) {
            return;
        }

        const visiblePages = this.resources.get("visiblePages").value;
        for (const visiblePage of visiblePages) {
            if (!!tokenLinesComp.tokenLines[visiblePage.id]) {
                continue;
            }

            const tokenRangeBoxes = visiblePage.tokenRanges.flatMap(range => createTokenRangeBoxes(range.fromTok, range.toTok + 1, this.resources.get("pageTokens").value));
            tokenLinesComp.tokenLines[visiblePage.id] = tokenRangeBoxes.map((x, index) => {
                return {
                    ...x,
                    index: index
                }
            });
        }
    }
}
